import React from 'react'
import ReactDOM from 'react-dom'

// eslint-disable-next-line import/no-unresolved
import ReactNative from 'react-native'

import { Provider } from 'react-redux'
import * as Sentry from '@sentry/browser'
import * as FullStory from '@fullstory/browser'
import SentryFullStory from '@sentry/fullstory'

import App from './components/App'
import { createFeatureFlagProvider } from './flags'
import { connectSocket, forceSaveComponents } from './utils/io'
import store from './redux-store'
import './shims'

const loadApp = async () => {
  // Set window globals for React, and Proton
  window.React = React
  window.ReactNative = ReactNative
  window.protonLibraries = {}

  const beforeUnload = e => {
    forceSaveComponents()
  }

  window.onbeforeunload = beforeUnload

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      forceSaveComponents()
    }
  })

  if (process.env.NODE_ENV === 'production') {
    console.info('Starting Fullstory')
    FullStory.init({ orgId: 'B779B', namespace: 'FS', debug: false })

    Sentry.init({
      dsn: 'https://6c6c4d20a449413590a7cc9bc08bfef2@sentry.io/1299301',
      integrations: [new SentryFullStory('adaloteam')],
      denyUrls: [/s3\.amazonaws\.com\/component-marketplace-(dev|prod)/i],
      ignoreErrors: ['Component Error [libraryComponent]'],
      sampleRate: 0.25, // error sample rate
    })
  }

  connectSocket(store)
  const FeatureFlagProvider = await createFeatureFlagProvider(store)

  ReactDOM.render(
    <Provider store={store}>
      <FeatureFlagProvider>
        <App />
      </FeatureFlagProvider>
    </Provider>,
    document.getElementById('root')
  )
}

loadApp()
